import { usePathname, useRouter } from 'next/navigation';

import type { MouseEvent } from 'react';

import type {
  MainModalController} from '@uikit';
import {
  Button,
  HorizontalSeparator,
  Modal,
  ModalClose,
  ModalCloseButton,
  ModalContent,
} from '@uikit';

import Close from '@uikit/icons/Close';

export interface HotOfferFailModalProps {
  modalController: MainModalController;
  onRetry: (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  claimUrl?: string;
}

export default function HotOfferFailModal({
  modalController: modal,
  onRetry,
  claimUrl,
}: HotOfferFailModalProps) {
  const pathname = usePathname();
  const router = useRouter();

  const handleOnOpenChange = (value: boolean) => {
    router.replace(pathname);

    modal.props.onOpenChange(value);
  };

  const modalProps = { ...modal.props, onOpenChange: handleOnOpenChange };

  return (
    <Modal {...modalProps}>
      <ModalContent className="items-center p-0">
        <ModalCloseButton className="m-4" />

        <div className="flex flex-col items-center p-10 pt-0">
          <div className="flex items-center justify-center w-[40px] aspect-square bg-red-600 rounded-full">
            <Close className="icon text-neutral-50" />
          </div>

          <h5 className="t-h4 text-xl">Oops!</h5>

          <HorizontalSeparator className="my-6" lineClassName="!bg-neutral-300" />

          <p className="t-body2 text-neutral-400 text-center">
            Token purchase failed.
            <br />
            Please double-check payment details and retry.
          </p>

          <div className="w-full flex gap-4">
            <ModalClose>
              <Button
                variant="outline"
                className="w-[200px] rounded-full mt-6 p-5 h-[60px] flex items-center justify-center border border-secondary-600 text-secondary-600 t-body2"
              >
                Close
              </Button>
            </ModalClose>

            <Button
              {...(claimUrl
                ? {
                    as: 'a',
                    href: claimUrl,
                    target: '_blank',
                    rel: 'noreferrer',
                  }
                : {})}
              variant="secondary"
              onClick={onRetry}
              className="w-[200px] rounded-full mt-6 p-5 h-[60px] flex items-center justify-center border border-secondary-600 text-neutral-50 t-body2"
            >
              Retry
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
}
